// import {
//     Avatar,
//     Box,
//     Badge,
//     Card,
//     CardContent,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemAvatar,
//     ListItemText,
//     Typography,
//     Fade,
//     Grid
// } from '@mui/material';

// import { IconArrowLeft, IconArrowRight } from '@tabler/icons';
// import React, { useState, useEffect } from 'react';

// function formatConversationTimestamp(isoString) {
//     const date = new Date(isoString);

//     // sempre ajusta para o fuso de São Paulo
//     const options = { timeZone: 'America/Sao_Paulo' };
//     const today = new Date().toLocaleDateString('pt-BR', options);
//     const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options); // -1 dia

//     const dateStr = date.toLocaleDateString('pt-BR', options);

//     if (dateStr === today) {
//         // se for hoje → retorna HH:mm
//         return date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     } else if (dateStr === yesterday) {
//         // se for ontem → retorna "ontem"
//         date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//         return `ontem ás ${date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         })}`;
//     } else {
//         // se for antes de ontem → retorna só dia/mês
//         return date.toLocaleDateString('pt-BR', {
//             ...options,
//             day: '2-digit',
//             month: '2-digit'
//         });
//     }
// }

// function stringToColor(string) {
//     let hash = 0;
//     let i;

//     /* eslint-disable no-bitwise */
//     for (i = 0; i < string.length; i += 1) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }

//     let color = '#';

//     for (i = 0; i < 3; i += 1) {
//         const value = (hash >> (i * 8)) & 0xff;
//         color += `00${value.toString(16)}`.slice(-2);
//     }
//     /* eslint-enable no-bitwise */

//     return color;
// }

// function stringAvatar(name) {
//     return {
//         sx: {
//             bgcolor: stringToColor(name)
//         },
//         children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
//     };
// }

// const DealConversationCard = ({ deal, onClick }) => {
//     const conversation = deal.conversation_detail;

//     if (!conversation) return null;

//     return (
//         <Card
//             onClick={onClick}
//             sx={{
//                 p: 0.5,
//                 m: 0,
//                 minHeight: 120,
//                 width: '100%',
//                 background: '#DADADC', //EBEBED //#3b3737
//                 cursor: 'pointer',
//                 mb: 1,
//                 boxSizing: 'border-box',
//                 '&:hover': { backgroundColor: '#D5D5D9' }
//             }}
//         >
//             <CardContent
//                 sx={{
//                     p: 0,
//                     '&:last-child': {
//                         pb: 0
//                     }
//                 }}
//             >
//                 <Box display="flex" alignItems="center" gap={1}>
//                     {conversation.avatarUrl === '' && <Avatar {...stringAvatar(conversation.displayName)} />}
//                     {conversation.avatarUrl !== '' && <Avatar src={conversation.avatarUrl} />}
//                     {/* <Avatar src={conversation.avatarUrl} /> */}

//                     {/* <Box textAlign="center"> */}

//                     {/* <Typography variant="caption">{conversation.type}</Typography> */}
//                     {/* </Box> */}

//                     <Box flex={1}>
//                         <Typography variant="body2" fontWeight="bold">
//                             <Badge badgeContent={conversation.qtdUnread} color="success">
//                                 <Typography color="#0C0C0D">{conversation.displayName}</Typography>
//                             </Badge>
//                         </Typography>

//                         <Box display="flex" alignItems="center" gap={0.5}>
//                             {conversation.type_author_last_message === 'user' && <IconArrowLeft fontSize="small" />}
//                             {conversation.type_author_last_message === 'agent' && <IconArrowRight fontSize="small" />}

//                             <Typography variant="body2" color="textSecondary" noWrap>
//                                 <Typography color="#0C0C0D">{conversation.last_message || 'Sem última mensagem'}</Typography>
//                             </Typography>
//                         </Box>
//                         <Typography color="#0C0C0D" variant="body2" noWrap>
//                             R$ {deal.value || '-'}
//                         </Typography>

//                         <Box display="flex" textAlign="left">
//                             <Typography variant="caption" color="#0C0C0D">
//                                 {formatConversationTimestamp(conversation.last_message_time)}
//                             </Typography>
//                             <Avatar sx={{ width: 28, height: 28, marginLeft: 11 }} src={`/${conversation.type}_icon.png`} />
//                         </Box>
//                     </Box>
//                 </Box>
//             </CardContent>
//         </Card>
//     );
// };

// export default DealConversationCard;
import React, { useState, useRef, useEffect } from 'react';

import { Avatar, Box, Badge, Card, CardContent, Chip, Divider, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

import { IconArrowLeft, IconArrowRight } from '@tabler/icons';
import { encodePathSegments } from '../../../../utils/media-url';

const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';

function formatConversationTimestamp(isoString) {
    const date = new Date(isoString);

    const options = { timeZone: 'America/Sao_Paulo' };
    const today = new Date().toLocaleDateString('pt-BR', options);
    const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options);

    const dateStr = date.toLocaleDateString('pt-BR', options);

    if (dateStr === today) {
        return date.toLocaleTimeString('pt-BR', {
            ...options,
            hour: '2-digit',
            minute: '2-digit'
        });
    } else if (dateStr === yesterday) {
        return `ontem às ${date.toLocaleTimeString('pt-BR', {
            ...options,
            hour: '2-digit',
            minute: '2-digit'
        })}`;
    } else {
        return date.toLocaleDateString('pt-BR', {
            ...options,
            day: '2-digit',
            month: '2-digit'
        });
    }
}

function stringToColor(string) {
    let hash = 0;

    for (let i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

function stringAvatar(name) {
    const parts = name.split(' ');
    return {
        sx: {
            bgcolor: stringToColor(name)
        },
        children: `${parts[0]?.[0] || ''}${parts[1]?.[0] || ''}`
    };
}

const formatCurrencyBR = (value) => {
    if (value === null || value === undefined || value === '') return '';

    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(Number(value));
};

const DealConversationCard = ({ deal, appId, onClick }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const [order, setOrder] = useState(null);

    const fetchOrder = () => {
        if (deal.orders.length >= 1) {
            setOrder(deal.orders[0]);
        }
    };

    const getPrivateMediaUrl = (path) => {
        if (!path || !appId) return '';

        return `${BACKEND_SERVER}v1/apps/${appId}/media/${encodePathSegments(path)}`;
    };

    useEffect(() => {
        fetchOrder();
    }, [deal]);

    const conversation = deal.conversation_detail;
    if (!conversation) return null;

    // curto e estável, só pra o atendente conseguir distinguir/referenciar
    // qual card é qual quando a mesma conversa tem vários negócios (histórico)
    const dealShortId = deal.id ? `#${String(deal.id).replace(/-/g, '').slice(-6).toUpperCase()}` : '';

    const outcomeBorderColor =
        deal?.outcome === 'won'
            ? isDark
                ? 'rgba(40,180,90,0.55)'
                : 'rgba(20,120,60,0.45)'
            : deal?.outcome === 'lost'
              ? isDark
                  ? 'rgba(200,60,60,0.55)'
                  : 'rgba(160,40,40,0.45)'
              : null;

    return (
        <Card
            onClick={onClick}
            sx={{
                borderRadius: '22px',
                cursor: 'pointer',
                mb: 1.5,
                opacity: deal?.outcome && deal.outcome !== 'open' ? 0.75 : 1,
                border: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.16)',
                borderLeft: outcomeBorderColor ? `4px solid ${outcomeBorderColor}` : undefined,
                background: isDark
                    ? `
                    linear-gradient(180deg, rgba(18,44,72,0.45), rgba(6,16,28,0.65))
                `
                    : `
                    linear-gradient(180deg, rgba(235,247,255,0.95), rgba(214,238,255,0.75))
                `,
                backdropFilter: 'blur(14px)',
                boxShadow: isDark
                    ? `
                    0 0 20px rgba(0,180,255,0.08),
                    inset 0 0 18px rgba(120,220,255,0.03),
                    inset 0 1px 0 rgba(255,255,255,0.05)
                `
                    : `
                    0 0 14px rgba(0,140,255,0.10),
                    inset 0 0 14px rgba(0,140,255,0.04),
                    inset 0 1px 0 rgba(255,255,255,0.6)
                `,
                transition: 'all 0.25s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    border: isDark ? '1px solid rgba(140,240,255,0.35)' : '1px solid rgba(0,140,255,0.40)',
                    boxShadow: isDark
                        ? `
                        0 0 30px rgba(0,200,255,0.16),
                        inset 0 0 25px rgba(120,220,255,0.06)
                    `
                        : `
                        0 0 20px rgba(0,150,255,0.18),
                        inset 0 0 18px rgba(0,150,255,0.07)
                    `
                }
            }}
        >
            <CardContent
                sx={{
                    p: 2,
                    '&:last-child': { pb: 2 }
                }}
            >
                <Box display="flex" alignItems="center" gap={1.5}>
                    {/* Avatar */}
                    {conversation.avatarUrl === '' ? (
                        <Avatar
                            {...stringAvatar(conversation.displayName)}
                            sx={{
                                width: 42,
                                height: 42,
                                boxShadow: isDark ? '0 0 10px rgba(0,180,255,0.3)' : '0 0 8px rgba(0,140,255,0.28)'
                            }}
                        />
                    ) : (
                        <Avatar
                            src={conversation.avatarUrl}
                            sx={{
                                width: 42,
                                height: 42,
                                boxShadow: isDark ? '0 0 10px rgba(0,180,255,0.3)' : '0 0 8px rgba(0,140,255,0.28)'
                            }}
                        />
                    )}

                    <Box flex={1}>
                        {/* Nome + badge */}
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Badge
                                badgeContent={conversation.qtdUnread}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        background: isDark ? 'rgba(120,240,255,0.9)' : 'rgba(0,140,255,0.85)',
                                        color: isDark ? '#001018' : '#fff',
                                        boxShadow: isDark ? '0 0 10px rgba(120,240,255,0.8)' : '0 0 8px rgba(0,140,255,0.5)'
                                    }
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 500,
                                        color: isDark ? 'rgba(255,255,255,0.92)' : 'rgba(8,35,60,0.90)'
                                    }}
                                >
                                    {conversation.displayName}
                                </Typography>
                            </Badge>

                            <Typography
                                sx={{
                                    fontSize: 11,
                                    color: isDark ? 'rgba(255,255,255,0.45)' : 'rgba(8,35,60,0.45)'
                                }}
                            >
                                {formatConversationTimestamp(conversation.last_message_time)}
                            </Typography>
                        </Box>

                        {/* Identificador curto do negócio - distingue cards da mesma conversa */}
                        <Typography
                            sx={{
                                fontSize: 10,
                                fontFamily: 'monospace',
                                color: isDark ? 'rgba(255,255,255,0.35)' : 'rgba(8,35,60,0.40)'
                            }}
                        >
                            {dealShortId}
                        </Typography>

                        {/* Última mensagem */}
                        <Box display="flex" alignItems="flex-start" gap={0.6} mt={0.5}>
                            {conversation.type_author_last_message === 'user' && (
                                <IconArrowLeft
                                    size={14}
                                    color={isDark ? '#7ee7ff' : '#0091ea'}
                                    style={{ flexShrink: 0, marginTop: 2 }}
                                />
                            )}

                            {conversation.type_author_last_message === 'agent' && (
                                <IconArrowRight size={14} color={isDark ? '#7ee7ff' : '#0091ea'} style={{ flexShrink: 0, marginTop: 2 }} />
                            )}

                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: isDark ? 'rgba(255,255,255,0.65)' : 'rgba(8,35,60,0.65)',

                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',

                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical',

                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    lineHeight: 1.4,
                                    minWidth: 0,
                                    flex: 1
                                }}
                            >
                                {conversation.last_message || 'Sem mensagem'}
                            </Typography>
                        </Box>

                        {/* Valor + tipo */}
                        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: isDark ? 'rgba(180,245,255,0.85)' : 'rgba(0,110,180,0.9)'
                                }}
                            >
                                {formatCurrencyBR(order?.total_value) || '-'}
                            </Typography>
                            {order?.status === 'draft' && <Chip label="Rascunho" size="small" />}
                            {order?.status === 'pending' && (
                                <Chip
                                    sx={{ background: '#D0D622', color: '#708076', textTransform: 'none', fontWeight: 600 }}
                                    label="Pendente"
                                    size="small"
                                />
                            )}
                            {order?.status === 'approved' && (
                                <Chip
                                    sx={{ background: '#06731B', color: '#D4D7D9', textTransform: 'none', fontWeight: 600 }}
                                    label="Aprovado"
                                    size="small"
                                />
                            )}
                            {order?.status === 'paid' && (
                                <Chip
                                    sx={{ background: '#27F550', color: '#708076', textTransform: 'none', fontWeight: 600 }}
                                    label="Pago"
                                    size="small"
                                />
                            )}
                            {/* 'finalizada' e 'canceled' não têm chip próprio aqui: o chip de
                                resultado do negócio (Ganho/Perdido) logo abaixo já cobre esse
                                terminal, evita duplicar a mesma informação em dois chips */}
                            {order?.status === 'refunded' && (
                                <Chip
                                    sx={{ background: '#2192DE', color: '#D4D7D9', textTransform: 'none', fontWeight: 600 }}
                                    label="Reembolsado"
                                    size="small"
                                />
                            )}
                        </Box>

                        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={1}>
                            {/* <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}> */}
                            {deal?.status === 'quente' && <Chip sx={{ textTransform: 'none', fontWeight: 600 }} label="🔥" size="small" />}
                            {deal?.status === 'morno' && <Chip sx={{ textTransform: 'none', fontWeight: 600 }} label="☁️" size="small" />}
                            {deal?.status === 'frio' && <Chip sx={{ textTransform: 'none', fontWeight: 600 }} label="❄️" size="small" />}

                            {deal?.outcome === 'won' && (
                                <Chip
                                    sx={{ background: '#1B7A3D', color: '#D4D7D9', textTransform: 'none', fontWeight: 600, ml: 0.5 }}
                                    label="Ganho"
                                    size="small"
                                />
                            )}
                            {deal?.outcome === 'lost' && (
                                <Chip
                                    sx={{ background: '#8A2323', color: '#D4D7D9', textTransform: 'none', fontWeight: 600, ml: 0.5 }}
                                    label="Perdido"
                                    size="small"
                                />
                            )}

                            {/* Channel */}
                            <Avatar
                                sx={{
                                    width: 26,
                                    height: 26,
                                    border: isDark ? '1px solid rgba(120,220,255,0.2)' : '1px solid rgba(0,120,220,0.25)',
                                    background: isDark ? 'rgba(20,40,60,0.6)' : 'rgba(225,242,255,0.8)'
                                }}
                                src={`/${conversation.type}_icon.png`}
                            />

                            {/* Assign */}
                            <Avatar
                                sx={{
                                    width: 26,
                                    height: 26,
                                    border: isDark ? '1px solid rgba(120,220,255,0.2)' : '1px solid rgba(0,120,220,0.25)',
                                    background: isDark ? 'rgba(20,40,60,0.6)' : 'rgba(225,242,255,0.8)'
                                }}
                                src={getPrivateMediaUrl(deal?.assign_detail?.avatar_img)}
                            >
                                {!deal?.assign_detail?.avatar_img && deal?.assign_detail?.first_name?.charAt(0)}
                            </Avatar>
                            {/* <Typography>{deal?.assign_detail?.avatar_img}</Typography> */}
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DealConversationCard;
